import { render, staticRenderFns } from "./wxOfficial.vue?vue&type=template&id=daf56810&scoped=true"
import script from "./wxOfficial.vue?vue&type=script&lang=js"
export * from "./wxOfficial.vue?vue&type=script&lang=js"
import style0 from "./wxOfficial.vue?vue&type=style&index=0&id=daf56810&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daf56810",
  null
  
)

export default component.exports